import { render, staticRenderFns } from "./PropsAttachment.vue?vue&type=template&id=874112c6&scoped=true"
import script from "./PropsAttachment.vue?vue&type=script&lang=js"
export * from "./PropsAttachment.vue?vue&type=script&lang=js"
import style0 from "./PropsAttachment.vue?vue&type=style&index=0&id=874112c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874112c6",
  null
  
)

export default component.exports